<template>
	<div id="loading">
		<Spin fix :class="!background?'noBack':''">
			<div class="square"></div>
			<p style="color: #264653;">加载中</p>
		</Spin>
	</div>
</template>

<script>
	export default {
		props: ['background'],
		data() {
			return {}
		},

	}
</script>

<style>
	.noBack {
		background-color: rgba(255, 255, 255, 0) !important;
	}

	.square {
		width: 20px;
		height: 20px;
		border: 1px rgba(38, 70, 83, 1) solid;
		margin: 10px auto;
		position: relative;
		-webkit-animation: fill_color 5s linear infinite;
		-moz-animation: fill_color 5s linear infinite;
		animation: fill_color 5s linear infinite;
	}

	.square:after {
		width: 4px;
		height: 4px;
		position: absolute;
		content: "";
		background-color: rgba(38, 70, 83, 1);
		top: -8px;
		left: 0px;
		-webkit-animation: square_check 1s ease-in-out infinite;
		-moz-animation: square_check 1s ease-in-out infinite;
		animation: square_check 1s ease-in-out infinite;
	}

	@-webkit-keyframes square_check {
		25% {
			left: 22px;
			top: -8px;
		}

		50% {
			left: 22px;
			top: 22px;
		}

		75% {
			left: -9px;
			top: 22px;
		}

		100% {
			left: -9px;
			top: -7px;
		}
	}

	@-moz-keyframes square_check {
		25% {
			left: 22px;
			top: -8px;
		}

		50% {
			left: 22px;
			top: 22px;
		}

		75% {
			left: -9px;
			top: 22px;
		}

		100% {
			left: -9px;
			top: -7px;
		}
	}

	@keyframes square_check {
		25% {
			left: 22px;
			top: -8px;
		}

		50% {
			left: 22px;
			top: 22px;
		}

		75% {
			left: -9px;
			top: 22px;
		}

		100% {
			left: -9px;
			top: -7px;
		}
	}

	@-webkit-keyframes fill_color {
		0% {
			box-shadow: inset 0px 0px 0px 0px rgba(38, 70, 83, 0.1);
		}

		100% {
			box-shadow: inset 0px -20px 0px 0px rgba(38, 70, 83, 1);
		}
	}

	@-moz-keyframes fill_color {
		0% {
			box-shadow: inset 0px 0px 0px 0px rgba(38, 70, 83, 0.1);
		}

		100% {
			box-shadow: inset 0px -20px 0px 0px rgba(38, 70, 83, 1);
		}
	}

	@keyframes fill_color {
		0% {
			box-shadow: inset 0px 0px 0px 0px rgba(38, 70, 83, 0.1);
		}

		100% {
			box-shadow: inset 0px -20px 0px 0px rgba(38, 70, 83, 1);
		}
	}
</style>
